import React, {Component} from "react";
import Header from "../components/Header/header";
import {Link} from "react-router-dom";

class Success extends Component {
	render() {
		return (
			<div className="flex column">
				<Header inicio={true}></Header>
				<div className="justify-center">
					<div className="container">
						<div className="column politicas">
							<div className="white-space-48"></div>
							<div className="checkpay justify-center">
								<div className="container column wow fadeIn">
									<div className="wow fadeIn">
										<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
											<circle
												className="path circle"
												fill="none"
												stroke="#000000"
												strokeWidth="6"
												strokeMiterlimit="10"
												cx="65.1"
												cy="65.1"
												r="62.1"
											/>
											<polyline
												className="path check"
												fill="none"
												stroke="#000000"
												strokeWidth="6"
												strokeLinecap="round"
												strokeMiterlimit="10"
												points="100.2,40.2 51.5,88.8 29.8,67.5 "
											/>
										</svg>
									</div>

									<div className="white-space-32" />
									<h2 className="color-black text-center wow fadeIn">
										¡FELICIDADES, COMPRA EXITOSA!
									</h2>
									<div className="white-space-16 " />
									<div className="btn-container-check-status justify-center wow fadeIn">
										<Link className="btn btn-red color-white" to="/">
											INICIO
										</Link>
									</div>
								</div>
							</div>
							<div className="white-space-48"></div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Success;



// WEBPACK FOOTER //
// ./src/pages/success.js